import { Button, ButtonProps, Flex, Tooltip } from "antd";
import type { SizeType } from "antd/es/config-provider/SizeContext";
import styles from "./button.module.css";

interface IProps extends Omit<ButtonProps, "size" | "className"> {
  tooltip?: string;
  withPlusIcon?: boolean;
  fullWidth?: boolean;
  size?: SizeType | "xlarge";
  className?: string;
}

export const CustomButton: React.FC<IProps & React.RefAttributes<HTMLButtonElement | HTMLAnchorElement>> = ({
  tooltip,
  withPlusIcon,
  fullWidth,
  size,
  className,
  type = "primary",
  ...props
}) => {
  const isXLarge = size === "xlarge";
  const antdSize = isXLarge ? "large" : size;

  const buttonClassName = [
    styles.button,
    fullWidth ? "full-width" : "",
    isXLarge ? styles.xlarge : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  const button = (
    <Flex className={`${className || ""} ${fullWidth ? "full-width" : ""}`}>
      <Button
        color="default"
        type={type}
        className={buttonClassName}
        icon={props.icon}
        size={antdSize as SizeType}
        {...props}
      >
        {props.children}
      </Button>
    </Flex>
  );

  if (tooltip) {
    return (
      <Flex>
        <Tooltip title={tooltip}>{button}</Tooltip>
      </Flex>
    );
  }

  return button;
};
